// event-bus.js

const orderCustomerStatus = {
    TAT_CA : -1,
    CHUA_HOAN_THANH: 0,
    HOAN_THANH: 1,
    HUY: 2,
}
const orderStatus={
    KHOI_TAO: 1,
    SAN_SANG: 2,
    CHO_XAC_NHAN: 3,
    CHO_NHAN_HANG: 4,
    DANG_VAN_CHUYEN: 5,
    HOAN_THANH: 6,
    DA_HUY: 7,
}
const locationType = {
    Destination: 1,
    Arrival: 2
}
export default {
    locationType,
    orderCustomerStatusConstant:orderCustomerStatus,
    orderStatusConstant:orderStatus,
    orderCustomerStatus: [
        {
            value: orderCustomerStatus.TAT_CA,
            text: "Tất cả",
            color: '#F3A93F',
        },
        {
            value: orderCustomerStatus.CHUA_HOAN_THANH,
            text: "Chưa hoàn thành",
            color: '#F3A93F',
        },

        {
            value: orderCustomerStatus.HOAN_THANH,
            text: "Hoàn thành",
            color: 'green',
        },
        {
            value: orderCustomerStatus.HUY,
            text: "Hủy",
            color: '#343a40',
        },
    ],
    orderStatus:[
        {
            value: orderStatus.KHOI_TAO,
            text: "Chờ giao cho đối tác vận tải",
            color: '#039cfd',
          },
          {
            value: orderStatus.SAN_SANG,
            text: "Sẵn sàng",
            color: '#6c757d',
          },
          {
            value: orderStatus.CHO_XAC_NHAN,
            text: "Chờ xác nhận",
            color: '#aa315b',
          },
          {
            value: orderStatus.CHO_NHAN_HANG,
            text: "Chờ nhận hàng",
            color: '#9d5508',
          },
        
          {
            value: orderStatus.DANG_VAN_CHUYEN,
            text: "Đang vận chuyển",
            color: '#678bfb',
          },
          {
            value: orderStatus.HOAN_THANH,
            text: "Hoàn thành",
            color: '#52bb56',
          },
          {
            value: orderStatus.DA_HUY,
            text: "Hủy",
            color: '#343a40',
          },
    ],
   
    
}